"use client";

import { Header } from "@/components/layout/header";
import { AppSidebar } from "@/components/layout/sidebar";
import { Footer } from "@/components/layout/footer";
import { cn } from "@/lib/utils";
import type React from "react";
import { useSidebar } from "./sidebar-context";
import RequireAuth from "@/components/auth/require-auth";

export function MainLayout({ children }: { children: React.ReactNode }) {
  const { collapsed } = useSidebar();

  return (
    <RequireAuth>
      <div className="flex min-h-screen">
        <div className="z-50 relative">
          <AppSidebar />
        </div>
        <div className={cn(collapsed ? "xl:w-[calc(100%-70px)]" : "xl:w-[calc(100%-250px)]", "flex min-h-screen w-full flex-col")}>
          <Header />
          <main className="flex-1 overflow-auto p-3 md:p-4 xxl:p-6">{children}</main>
          <Footer />
        </div>
      </div>
    </RequireAuth>
  );
}
